import Vue from 'vue'
import Router from 'vue-router'
import InfluSightsLogin from '@/components/InfluSightsLogin'
import InstagramConnect from '@/components/InstagramConnect'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: InfluSightsLogin
    },
    {
      path: '/connect-with-instagram',
      name: 'ConnectWithInstagram',
      component: InstagramConnect,
      props: {'name': name}
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js